import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const ContentCard = styled.section``;

export const Title = styled(Typography.Header)`
  margin-bottom: 22px;
`;
